export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-100-normal.woff2?7a5dea8b0e2bb553f613c842c37f3832";